export default __webpack_public_path__ + "static/media/industry-environment.038ac5ec.jpg";